/**
 * Main entry point used by web pack in gulp
 *  - Require any other components using require in here
 *
 * Example of local standalone scripts:
 *  require('./jquery/components/test.js');
 * Examples of node module:
 *  require('bootstrap');
 * OR full path to specific js file
 *  require('../../node_modules/bootstrap/dist/js/bootstrap.min.js');
 */

require('./components/utils');
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';
import 'regenerator-runtime/runtime';

require('jquery-validation');
require('jquery-validation-unobtrusive');

if (!__PROD__) {
  require('jquery-migrate');
}

/**
 * Load ES6 modules dynamically
 **/
import moduleLoader from './module-loader';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    document.getElementsByTagName('html')[0].classList.remove('pre-init');
    document.getElementsByTagName('html')[0].classList.add('post-init');

    // ES6 modules loaded dynamically based on DOM query
    const modules = Array.from(document.querySelectorAll('[data-module]'));
    moduleLoader(modules);
  },
  false,
);
